import { IRecall } from "@core/interface";
import { ScheduleServices } from "../schedule/schedule-services.model";

export class RecallInfoModel {
  "recall": IRecall[];
  "recallService": ScheduleServices[];
  "hasRecall": boolean;
}
